import { generateTypes } from '../../utils/HttpReducerHelper';

export const activities = generateTypes('DASHBOARD', 'ACTIVITIES');
